/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Download2': {
    width: 22,
    height: 18,
    viewBox: '0 0 22 18',
    data: '<path pid="0" d="M11.89 1.236a.936.936 0 00-1.873 0v8.759L6.902 6.63A.936.936 0 105.528 7.9l4.738 5.12a.936.936 0 001.374 0l4.738-5.12a.936.936 0 00-1.374-1.271l-3.115 3.365V1.236zM2.691 8.821a.936.936 0 00-1.872 0v5.794a3.166 3.166 0 003.166 3.165H17.92a3.166 3.166 0 003.166-3.165V8.836a.936.936 0 10-1.872 0v5.779c0 .714-.58 1.293-1.293 1.293H3.986c-.715 0-1.294-.579-1.294-1.293V8.82z" _fill="#00204D" _stroke="#00204D" stroke-width=".2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
